<template>
  <div>
    <about-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj="titleObj"
    >
    </about-header>
    <about-us :aboutInfo="about"></about-us>
    <about-culture :cultureInfo="culture"></about-culture>
    <!-- <about-process :developList="developList" ref="processRef"></about-process> -->
    <about-honor :honorContent="honorContent" ref="honorRef"></about-honor>
    <about-power :powerList="powerList" ref="powerRef"></about-power>
    <about-team :teamList="teamList"></about-team>
    <about-contact></about-contact>
    <about-footer
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :bottomNews="bottomNews"
      :productType="productType"
    >
    </about-footer>
  </div>
</template>

<script>
import AboutHeader from "@/components/pc/Header";
import AboutUs from "@/components/pc/AboutUs";
import AboutCulture from "@/components/pc/AboutCulture";
import AboutProcess from "@/components/pc/AboutProcess";
import AboutTeam from "@/components/pc/AboutTeam";
import AboutContact from "@/components/pc/AboutContact";
import AboutFooter from "@/components/pc/Footer";
import AboutHonor from "@/components/pc/AboutHonor";
import AboutPower from "@/components/pc/AboutPower";
export default {
  name: "About",
  data() {
    return {
      screenStyle: {
        width: "",
        margin: "0 auto",
      },
      actIndex: 8, //页码
      topStyle: "", //页样式
      imgList: [], //轮播图
      bottom: {}, //底部信息
      logo: "", //logo
      bottomInfo: {}, //底部联系我们
      about: {}, //关于我们
      culture: {}, //公司文化
      developList: [], //发展历程
      teamList: [], //团队
      partner: [], //合作伙伴
      powerList: [], //软件著作权
      productType: [], //产品类别
      bottomNews: [],
      titleObj: {
        title: "恭谦  诚信  协作  超越",
        desc: "以匠为局，成就自我\n匠心研发，倾力服务",
      },
      background: require("../../static/images/about_head.png"),
      honorContent: [],
    };
  },
  components: {
    AboutHeader,
    AboutUs,
    AboutCulture,
    AboutProcess,
    AboutTeam,
    AboutContact,
    AboutPower,
    AboutFooter,
    AboutHonor,
  },
  mounted() {
    this.Pc_Mobile();
    this.getPowerList();
    this.getTeamList();
    this.screenStyle.width = document.body.clientWidth + "px";
    this.getPageData();
    this.getHeaderImage();
    // this.getHonorData();
    console.log('7111')
  },
  methods: {
    _isMobile() {
      console.log('7')
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_about");
      } else {
        this.$router.push("/about");
      }
    },
    getPowerList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/software_copyright",
        null,
        (res) => {
          // console.log(res.data)
          if (res.code == 1) {
            this.powerList = res.data;
          }
        }
      );
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle = "background-image:url('" + res.data.pc_image + "')";
          }
        }
      );
    },

    getTeamList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/team_style",
        null,
        (res) => {
          if (res.code == 1) {
            this.teamList = res.data;
          }
        }
      );
    },
    getPageData() {
      this.$http.post("https://eartisanapplets.wsandos.com/api/index/aboutPag", null, (res) => {
        // console.log(res.data)
        this.about = res.data.company[0];
        this.productType = res.data.type;
        this.$nextTick(() => {
          // this.$refs.honorRef.getHonorData();
          this.$refs.powerRef.imgSwiper();
          this.$refs.processRef.imgSwiper();
        });
      });
    },
    
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/pc/About.vue